/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  LSettingsProtocolsDeleteEmployeeRequest,
  LSettingsProtocolsRequestInvitationEmailRequest,
  LSettingsProtocolsSendInvitationRequest,
  LSettingsProtocolsUpdateEmployeeRoleRequest,
  MarqCommonProtocolEmptyResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class LSettings<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags LSettings
   * @name SettingsSendInvitationCreate
   * @request POST:/legacy/settings/send-invitation
   */
  settingsSendInvitationCreate = (data: LSettingsProtocolsSendInvitationRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/legacy/settings/send-invitation`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags LSettings
   * @name SettingsRequestInvitationEmailCreate
   * @request POST:/legacy/settings/request-invitation-email
   */
  settingsRequestInvitationEmailCreate = (
    data: LSettingsProtocolsRequestInvitationEmailRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/legacy/settings/request-invitation-email`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags LSettings
   * @name SettingsUpdateEmployeeRoleCreate
   * @request POST:/legacy/settings/update-employee-role
   */
  settingsUpdateEmployeeRoleCreate = (data: LSettingsProtocolsUpdateEmployeeRoleRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/legacy/settings/update-employee-role`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags LSettings
   * @name SettingsDeleteEmployeeCreate
   * @request POST:/legacy/settings/delete-employee
   */
  settingsDeleteEmployeeCreate = (data: LSettingsProtocolsDeleteEmployeeRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/legacy/settings/delete-employee`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
